module.exports = __webpack_public_path__ + "static/media/twitter.f60435e9.svg";